import { useMemo } from 'react';

// Constants
import {
  GROSS_RENT_CERT_TYPE,
  RD_GROSS_RENT_CERT_TYPE,
} from '../../constants/affordableCertificationTypes';

/**
 * Hook to determine if the download all button should be disabled
 * @param {Object} params - The parameters for the hook
 * @param {string} params.selectedCertificationType - The currently selected certification type
 * @param {Array} params.sortedAndFilteredResults - The sorted and filtered certification results
 * @returns {boolean} Whether the download all button should be disabled
 */
const useDisableDownloadAllButton = ({
  selectedCertificationType,
  sortedAndFilteredResults,
}) => {
  return useMemo(() => {
    if (
      (selectedCertificationType !== GROSS_RENT_CERT_TYPE ||
        selectedCertificationType !== RD_GROSS_RENT_CERT_TYPE) &&
      !sortedAndFilteredResults.length
    ) {
      return true;
    }

    // Check if there are any certifications that can't be generated for RD
    const hasGenerationRestrictions =
      selectedCertificationType === RD_GROSS_RENT_CERT_TYPE
        ? sortedAndFilteredResults.some((grossRentCertification) => {
            const {
              isCorrection,
              correction,
              priorCertificationDate,
              priorActiveCert,
            } = grossRentCertification;

            // Condition to disable due to missing correction when it should exist
            const isCorrectionMissing = isCorrection === 'yes' && !correction;
            // Certification is considered invalid if it lacks a prior certification date,
            // has a missing correction when required, or has an active prior certification
            return (
              !priorCertificationDate ||
              isCorrectionMissing ||
              !!priorActiveCert
            );
          })
        : false;

    return hasGenerationRestrictions;
  }, [selectedCertificationType, sortedAndFilteredResults]);
};

export default useDisableDownloadAllButton;
